module.exports = __webpack_public_path__ + "static/media/Partner8.52cd3760.webp";